import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { STATUS_BASE_PATH } from "./modules/utils";

export default store => ({
  path: `${STATUS_BASE_PATH}(/**)`,
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "status" */ "./components"),
      import(/* webpackChunkName: "status" */ "./modules/SyncStatusModule"),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;

      const reducer = importedModule1.default;
      const reducerName = importedModule1.NAME;

      injectReducer(store, {
        key: reducerName,
        reducer,
      });
      return component;
    })
  ),
  childRoutes: [],
});
